module.exports = __webpack_public_path__ + "static/img/zgxqy.b1f2cd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daping/zgxqy.png
// module id = CywB
// module chunks = 0